import { CircleButton } from 'pages/Shifts/Shifts.styled'
import { Flex } from 'styling/GlobalStyles'
import { SquareCheckBox } from './CheckBox.styled'
import { BodyText, OtherText } from 'styling/Typography'
import { CheckBoxIcon } from './CheckBoxIcon'

export const CheckBox = ({
  state,
  onClick,
  title,
  square,
  fit,
  bodyText,
}: {
  state: boolean
  onClick?: () => void
  title: string
  square?: boolean
  fit?: boolean
  bodyText?: boolean
}) => {
  const Title = bodyText ? BodyText : OtherText

  return (
    <Flex center gap='1rem' width='100%' height='1.5rem' onClick={onClick}>
      {square ? (
        <SquareCheckBox active={state}>{state && <CheckBoxIcon />}</SquareCheckBox>
      ) : (
        <CircleButton checked={state} />
      )}
      <Title>{title}</Title>
    </Flex>
  )
}
